export default __webpack_public_path__ + "static/media/Floor-Plan-3D.771d7cfd.jpg";